module.exports = __webpack_public_path__ + "img/mine30VIP.69352b6a.webp";